import { SimpleDirectedGraph } from "../graph/directed/simple-directed-graph";
import { Node } from "../graph/lib/node";
import { ColorTreeGrid } from "./colorTree/color-tree-grid";
import { ColorTreeNode } from "./colorTree/color-tree-node";
import { TreeNode } from "./lib/tree-node";
import { TreeEdge } from "./lib/tree-edge";

export abstract class TreeBuilder extends SimpleDirectedGraph {
    protected set: any[];
    protected depth: number;
    protected root: TreeNode;

    protected selectedNode: TreeNode;

    static readonly minRow: number = 8;
    static readonly minCol: number = 13;

    constructor(depth: number, set: any[], canvas: HTMLCanvasElement) {

        let row = Math.max((depth) * 2 + 3, TreeBuilder.minRow);
        let col = Math.max(Math.pow(set.length + 1, depth), TreeBuilder.minCol);

        super(canvas, row, col);
        this.setGrid(new ColorTreeGrid(row, col, canvas));
        this.set = set;
        this.depth = depth;

        this.update();
        this.selectedNode = null;
    }

    getSelectedNode(): TreeNode{
        return this.selectedNode;
    }

    resetSelectedNode(){
        if(this.selectedNode != null){
            this.selectedNode.resetColor();
            this.selectedNode = null;
        }
    }

    protected abstract addTreeNode(row: number, col: number, parent: TreeNode, maxWidthTextCol?: number): TreeNode;
    /**
     * 
     * @param curDepth 
     * @returns the number of children at depth @param curDepth
     */
    protected abstract getNumberChild(curDepth: number): number;
    /**
     * 
     * @param curDepth 
     * @returns the number of children of a single node
     * 
     * This method is only used by buildTree
     */
    protected abstract childrenSize(curDepth: number): number;

    getSet():any[]{
        return this.set;
    }

    getDepth():number{
        return this.depth;
    }

    getHiddenNodes(): TreeNode[]{
        let hiddenNodes: TreeNode[] = [];
        this.nodes.forEach(node => {
            if(node instanceof TreeNode){
                let tNode : TreeNode = <TreeNode>node;
                if(tNode.isHidden()){
                    hiddenNodes.push(tNode);
                }
            }
        });

        return hiddenNodes;
    }


    buildTree() {
        let root: [number, number] = this.getCTGrid().getRootCoordinates();
        let rootNode = this.addTreeNode(root[0], root[1], null);
        this.root = rootNode;

        let level = root[0] + 2;
        let i: number = 0;
        let j: number = 0;
        let numberChild: number = 0;
        let parents: TreeNode[] = [rootNode];
        let parent: TreeNode;
        //We iterate through each level
        for (i = 1; i <= this.depth; i++) {
            numberChild = this.getNumberChild(i);
            let distance: number = this.cols / (numberChild + 1); //+1, because we need to include space for the boarder nodes
            for (j = 0; j < numberChild; j++) {
                if (j % this.childrenSize(i) == 0) {
                    parent = parents.shift();
                }
                parents.push(this.addTreeNode(level, distance * (j + 1), parent, distance));
            }
            level = level + 2;
        }
    }

    addEdge(from: Node, to: Node) {
        if (from == to)
            return;

        //Node has been deleted, hence cant be used to connect
        if (this.nodes.indexOf(from) == -1 || this.nodes.indexOf(to) == -1) {
            return;
        }

        from.addNeighbor(to);
        if (!this.existsEdge(from, to)) {
            this.edges.push(new TreeEdge(from, to));
        }
        this.update();

    }

    getCTGrid(): ColorTreeGrid {
        if (this.grid instanceof ColorTreeGrid) {
            return this.grid;
        }

    }

    setLevelVisible(visible: boolean) {
        this.getCTGrid().setLevelsVisible(visible);
    }
    doubleClick(row: number, col: number, node: Node, e: MouseEvent) {
        return;
    }

    leftClick(row: number, col: number, node: Node, e: MouseEvent) {
        let n: TreeNode = null;
        this.nodes.forEach(cur => {
            if (cur.inParameter(e, this.getCTGrid())) {
                if (cur instanceof TreeNode) {
                    n = <TreeNode>cur;
                    this.leftClickTreeNode(n);
                }
            }
        })
        if (n != null) {
        }else{
        }


    }

    abstract leftClickTreeNode(treeNode: TreeNode);

    abstract keyboardEvent(e: KeyboardEvent);

    rightClick(row: number, col: number, node: Node, e: MouseEvent) {
        return;
    }
}
